import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { RadioGroup, FormControl } from "@mui/material";
import Radio from "@mui/material/Radio";

export default function PaymentSummary({
  paymentMethod,
  setPaymentMethod,
}) {
  const handleChangePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };
  return (
    <>
      <div className="payment-sec">
        <h5>Choose a Payment Option</h5>
        <FormControl component="fieldset">
          <RadioGroup
            value={paymentMethod}
            onChange={handleChangePaymentMethod}
          >
            <FormControlLabel
              value="onlinePayment"
              control={<Radio />}
              label="Online Payment (Credit Card, Debit Card, Online Banking, UPI)"
            />
            <FormControlLabel
              value="COD"
              control={<Radio />}
              label="Cash On Delivery (COD)"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
}
